const permissionsList = Object.freeze({
  CAN_READ_COURSE: 'can_read_courses',
  CAN_CREATE_COURSE: 'can_create_courses',
  CAN_UPDATE_COURSE: 'can_update_courses',
  CAN_DELETE_COURSE: 'can_delete_courses',
});

export default permissionsList;
